import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top of the page whenever the route changes.
// React Router does NOT do this by default; without it, navigating from a
// scrolled position on one page to another keeps the previous scroll offset,
// which is confusing when landing on a brand-new detail page.
//
// Skips the reset when the URL has a #hash (anchor navigation to a section).
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
